import { render, staticRenderFns } from "./Comunismul.vue?vue&type=template&id=5766c1d1&"
import script from "./Comunismul.vue?vue&type=script&lang=js&"
export * from "./Comunismul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports